const isMobile = () => {
  return window.innerWidth <= 1024;
};

document.querySelectorAll(".mobileSlider").forEach((mobileSlider) => {
  if (isMobile() && !Flickity.data(mobileSlider)) {
    const flkty = new Flickity(mobileSlider, {
      // Flickity options for mobile devices
      initialIndex: 0,
      contain: true,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      imagesLoaded: true,
      draggable: true,
      cellAlign: "left",
    });
  } else if (!isMobile() && Flickity.data(mobileSlider)) {
    //Destroy
    Flickity.data(mobileSlider).destroy();
  }
});

window.addEventListener("resize", (e) => {
  document.querySelectorAll(".mobileSlider").forEach((mobileSlider) => {
    if (isMobile() && !Flickity.data(mobileSlider)) {
      const flkty = new Flickity(mobileSlider, {
        // Flickity options for mobile devices
        wrapAround: true,
        pageDots: false,
        cellAlign: "left",
        adaptiveHeight: false,
        draggable: true,
        prevNextButtons: false,
      });
    } else if (!isMobile() && Flickity.data(mobileSlider)) {
      //Destroy
      Flickity.data(mobileSlider).destroy();
    }
  });
});

// Mobile Footer Accordions:
const closeAllAccordions = () => {
  document
    .querySelectorAll(".footer__block.block__link-list .footer__menu ")
    .forEach((el) => {
      el.setAttribute("data-open", false);
    });
};
const closeAccordion = (el) => {
  el.setAttribute("data-open", false);
};
document
  .querySelectorAll(".footer__block.block__link-list .footer__menu ")
  .forEach((el) => {
    el.addEventListener("click", (e) => {
      const isOpen = el.getAttribute("data-open");
      //closeAllAccordions();
      if (isOpen === "false") el.setAttribute("data-open", true);
      else closeAccordion(el);
    });
  });

const filterOpener = document.querySelector(".filterOpenerMobile");
if (filterOpener) {
  const openSidebar = () => {
    document
      .querySelector(".collection__content .sidebar-section")
      .classList.add("viewSidebar");
  };
  const closeSidebar = () => {
    document
      .querySelector(".collection__content .sidebar-section")
      .classList.remove("viewSidebar");
  };

  filterOpener.addEventListener("click", (e) => {
    e.preventDefault();
    openSidebar();
  });

  const closeIcon = document.querySelector(
    ".collection__content .sidebar-section .closeFilters"
  );
  const sidebarOverlay = document.querySelector(
    ".collection__content .sidebar-section .sidebarMobileOverlay"
  );

  closeIcon.addEventListener("click", closeSidebar);
  sidebarOverlay.addEventListener("click", closeSidebar);
}

if (document.querySelector("body.product")) {
  let reviewCarousel;
  const awaitReviewCarousel = setInterval(() => {
    reviewCarousel = document.querySelector(
      "#reviewsio-carousel-widget .R-ReviewsList-container .R-ReviewsList"
    );
    if (reviewCarousel) {
      clearInterval(awaitReviewCarousel);
      const reviewItems = reviewCarousel.querySelectorAll(
        ".R-ReviewsList__item"
      );
      if (reviewItems.length > 10) {
        reviewCarousel.classList.add("showMoreBtn");
        reviewCarousel.style.maxHeight = "800px";
        reviewCarousel.innerHTML +=
          '<button class="showMoreButton" data-show-more="false">Show More</button>';
        const showMoreBtn = reviewCarousel.querySelector(".showMoreButton");
        showMoreBtn.addEventListener("click", (e) => {
          if (showMoreBtn.getAttribute("data-show-more") === "false") {
            reviewCarousel.classList.remove("showMoreBtn");
            reviewCarousel.style.maxHeight = reviewCarousel.scrollHeight + "px";
            showMoreBtn.innerText = "Show Less";
            showMoreBtn.setAttribute("data-show-more", true);
          } else {
            reviewCarousel.classList.add("showMoreBtn");
            reviewCarousel.style.maxHeight = "800px";
            showMoreBtn.innerText = "Show More";
            showMoreBtn.setAttribute("data-show-more", false);
          }
        });
      }
    }
  });
}

/* Product Page Kat Says First **/
if (
  document.querySelector(
    ".product-main .product_section .product-block.product-block--description"
  )
) {
  let smartTabsWrapper;

  const findKatSays = (wrapper) => {
    const allTabs = Array.from(
      wrapper.querySelectorAll(".smart-tabs-navigation-li")
    );
    const katSays = allTabs.find((tab) => tab.innerText.includes("Kate Says"));
    return katSays;
  };
  const awaitSmartTabsLoaded = setInterval(() => {
    smartTabsWrapper = document.querySelector(
      ".smart-tabs-wrapper .smart-tabs-navigation-links"
    );

    if (smartTabsWrapper) {
      clearInterval(awaitSmartTabsLoaded);
      const katSaysSection = findKatSays(smartTabsWrapper);
      if (katSaysSection) {
        katSaysSection.classList.add("katSaysAccordion");
        smartTabsWrapper.firstElementChild.click();
        smartTabsWrapper.insertBefore(
          katSaysSection,
          smartTabsWrapper.firstElementChild
        );
        katSaysSection.click();
      }
    }
  }, 1000);
}
/* Product Page Kat Says First End**/

/* Mega menus on hover **/
const onLeavingMegaMenuLink = (item) => {
  item.parentElement
    .querySelectorAll(".mega-hover")
    .forEach((ite) => ite.classList.remove("mega-hover"));
};

const onEnterMegaMenuLink = (item) => {
  onLeavingMegaMenuLink(item);
  item.classList.add("mega-hover");
};

const initializeBudhaHover = (megaMenuItems) => {
  megaMenuItems.forEach((item) => {
    item.addEventListener("mouseenter", onEnterMegaMenuLink.bind(this, item));
    item.addEventListener("mouseleave", onLeavingMegaMenuLink.bind(this, item));
  });
};

//Awaiting budha app to initialize and set up mega menus. Please remove in case the app is removed:
let megaMenuItems;
const awaitBudhaApp = setInterval(() => {
  megaMenuItems = document.querySelectorAll(
    "li.buddha-menu-item.navbar-item.header__item.has-mega-menu"
  );
  if (megaMenuItems.length) {
    clearInterval(awaitBudhaApp);
    initializeBudhaHover(megaMenuItems);
  }
}, 500);

/* Mega menus on hover end**/
